import { REACTING_MODES, type ReactingMode } from "../visuals/lightFrameEngine";
interface Props {
  mode: ReactingMode; rotationEnabled: boolean; showDebug: boolean;
  onModeChange: (mode: ReactingMode) => void; onRotationToggle: () => void;
}
export function PerformanceControls({ mode, rotationEnabled, showDebug, onModeChange, onRotationToggle }: Props) {
  if (!showDebug) return null;
  return <section className="instrument-section performance-controls" aria-labelledby="reacting-heading">
    <h2 id="reacting-heading" className="instrument-heading ruled-heading">REACTING</h2>
    <div className="performance-mode-list" role="group" aria-label="声音响应模式">
      {REACTING_MODES.map((item, index) => (
        <button key={item.id} type="button" aria-pressed={mode === item.id}
          title={item.description} onClick={() => onModeChange(item.id)}>
          <kbd>{index + 1}</kbd><span>{item.name}</span>
        </button>
      ))}
    </div>
    <button type="button" className="rotation-toggle" aria-pressed={rotationEnabled} onClick={onRotationToggle}
      title="R · 独立旋转；关闭后重拍仍推动光柱，不强制旋转">
      <span className="switch-track" aria-hidden="true"><span /></span>
      <kbd>R</kbd><span>独立旋转</span>
    </button>
  </section>;
}
